import { render } from "./ListeTypeFretPaiement.vue?vue&type=template&id=db465702&ts=true"
import script from "./ListeTypeFretPaiement.vue?vue&type=script&lang=ts"
export * from "./ListeTypeFretPaiement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__